import React from 'react';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {/* Back Button */}
        <Button
          variant="outline"
          onClick={() => navigate('/')}
          className="mb-8 border-2 hover:bg-gray-100"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Zurück zur Startseite
        </Button>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-12 border border-gray-200">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>
            Impressum
          </h1>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            {/* Company Info */}
            <section>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Angaben gemäss § 5 TMG</h2>
              <div className="space-y-2">
                <p className="font-semibold text-lg">Trees Life Charity</p>
                <p>Chaltenbodenstrasse 26</p>
                <p>CH-8834 Schindellegi</p>
                <p>Schweiz</p>
              </div>
            </section>

            {/* Contact */}
            <section>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Kontakt</h2>
              <div className="space-y-2">
                <p>
                  <span className="font-semibold">E-Mail:</span>{' '}
                  <a href="mailto:contact@trees-life.charity" className="text-[#FF1B8D] hover:underline break-all">
                    contact@trees-life.charity
                  </a>
                </p>
              </div>
            </section>

            {/* Legal Form */}
            <section>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Rechtsform</h2>
              <p>Gemeinnützige Organisation</p>
            </section>

            {/* Liability */}
            <section>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Haftungsausschluss</h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-lg mb-2">Haftung für Inhalte</h3>
                  <p className="text-gray-600">
                    Die Inhalte unserer Seiten wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-lg mb-2">Haftung für Links</h3>
                  <p className="text-gray-600">
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-lg mb-2">Urheberrecht</h3>
                  <p className="text-gray-600">
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem schweizerischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung ausserhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                  </p>
                </div>
              </div>
            </section>

            {/* Privacy */}
            <section>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Datenschutz</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies stets auf freiwilliger Basis.
                </p>
                <p>
                  Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
                </p>
                <p>
                  Ihre Daten werden ausschliesslich für die Bearbeitung Ihrer Anfrage bzw. Spende verwendet und nicht an Dritte weitergegeben.
                </p>
              </div>
            </section>

            {/* Tax Deductibility */}
            <section className="bg-gradient-to-br from-[#FF1B8D]/5 to-[#FF9B8C]/5 p-6 rounded-xl border-2 border-[#FF9B8C]/20">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">Steuerliche Absetzbarkeit</h2>
              <p className="text-gray-600">
                Trees Life Charity ist als gemeinnützige Organisation anerkannt. Spenden an unsere Organisation sind in der Schweiz steuerlich absetzbar. Auf Wunsch stellen wir Ihnen gerne eine Spendenbescheinigung aus.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;